<script setup lang="ts">
const {user, initialsForName} = useAuth()

defineProps<{
  isDark: boolean
}>()
</script>

<template>
  <div class="d-flex align-items-start border-light px-3 py-1 mt-2" style="width: 16rem">
    <div class="rounded-circle text-decoration-none text-light bg-primary p-2 mt-2" >
      {{ initialsForName }}
    </div>
    <div class="ps-2">
      <h6 class="fs-base mb-0" :class="isDark ? 'text-light' : 'text-dark'">{{ user?.name }}</h6>
      <div class="fs-xs py-2" :class="isDark ? 'text-light' : 'text-dark'">{{ user?.email }}</div>
    </div>
  </div>
</template>
